function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrackle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 999.99994,
    height: 178.47447,
    viewBox: "0 0 999.99995 178.47447",
    enableBackground: "new 0 0 1000 178.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(2.1574926,0,0,2.1574926,-1019.4757,-104.62113)",
    points: "826.166,48.492 846.945,48.492 846.945,112.967 878.206,112.967 878.206,131.087 826.166,131.087 ",
    id: "polygon52",
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 592.53378,8.4080003e-7 h 44.95999 V 178.19811 H 592.53378 Z M 697.04704,178.19811 h 56.46805 L 691.8971,85.751704 752.75134,8.4080003e-7 H 696.27466 L 666.96512,48.342939 l -24.1143,39.797109 -0.58468,0.960084 22.31064,35.139078 v 0 z",
    id: "path54",
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillRule: "evenodd",
      strokeWidth: 2.15749264
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(2.1574926,0,0,2.1574926,-1019.4757,-104.62113)",
    points: "903.705,66.612 903.705,79.937 931.233,79.937 931.233,98.047 903.705,98.047 903.705,112.967 936.029,112.967 936.029,131.087 882.927,131.087 882.927,48.492 935.141,48.492 935.141,66.612 ",
    id: "polygon56",
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 135.70629,8.4080003e-7 h 77.05485 c 40.64069,0 61.8963,26.61698715919997 61.8963,58.05812715919998 0,23.879129 -9.00106,42.023642 -32.80899,52.109922 l 39.22322,68.03006 H 236.24329 L 182.53898,87.015995 v -2.269683 h 26.38398 c 14.0798,0 25.70437,-11.026944 25.70437,-24.511274 0,-13.484329 -8.95576,-24.511274 -24.52207,-24.511274 H 180.54977 V 178.19811 H 135.70845 V 8.4080003e-7 Z",
    id: "path58",
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillRule: "evenodd",
      strokeWidth: 2.15749264
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 354.62491,102.537 H 392.5752 L 373.58711,41.505845 Z m 49.84239,38.29981 h -61.75607 l -11.61162,37.3613 H 283.36508 L 343.60012,8.4080004e-7 h 60.00203 L 463.8113,178.19811 h -47.73237 z",
    id: "path60",
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillRule: "evenodd",
      strokeWidth: 2.15749264
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 579.59961,2.0819818 V 37.829477 c -12.50051,-0.865154 -27.20166,-1.848971 -39.4929,0 -36.1229,5.406677 -46.21349,35.020421 -46.21349,51.268498 0,16.830595 11.73028,47.266345 50.21564,51.009595 11.16718,1.10248 24.55874,0.0712 35.4886,-0.3754 v 36.3818 c -18.93848,3.34627 -41.29657,3.55555 -61.98908,-2.1316 -39.16497,-10.48542 -61.74529,-43.30735 -61.74529,-84.884395 0,-41.577041 26.74644,-75.054854 62.79814,-84.8628162 20.69683,-5.68715 42.35158,-4.37539496 60.93838,-2.153177 z",
    id: "path62",
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillRule: "evenodd",
      strokeWidth: 2.15749264
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 123.7322,2.0819818 V 37.829477 c -12.50267,-0.865154 -27.203821,-1.848971 -39.48427,0 -36.133686,5.406677 -46.222122,35.020421 -46.222122,51.268498 0,16.830595 11.732445,47.266345 50.237216,51.009595 11.14345,1.10248 24.545796,0.0712 35.467026,-0.3754 v 36.3818 c -18.94063,3.34627 -41.298728,3.55555 -61.99124,-2.1316 C 22.580318,163.49695 0,130.67502 0,89.097975 0,47.520934 26.757224,14.043121 62.804611,4.2351588 83.488493,-1.4519912 105.14325,-0.14023616 123.7322,2.0819818 Z",
    id: "path64",
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillRule: "evenodd",
      strokeWidth: 2.15749264
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrackle);
export default __webpack_public_path__ + "static/media/crackle.a6164fbb1729d2e986771286896f0a80.svg";
export { ForwardRef as ReactComponent };